
<div class="tracks-top-row" [class.endscreen-enabled]="endscreenEnabled">
	<div class="button-container">
		<button-bar
			[items]="nonVisualWidgets"
			[includeAddButton]="true"
			[addLabel]="'ADD_NEW_TRACK' | translate"
			(onOpened)="onAddTrackButtonBarOpened()"
			(onItemSelected)="itemSelected($event)"
			(onMouseOverItem)="mouseOverItem($event)"
			(clickOutside)="closeButtonBar()">
		</button-bar>
	</div>
	<div *ngIf="interactivityEditorService.parentEntityType === 'MediaClip'" style="overflow: hidden;">
		<div class="bb-track-zoom" (click)="onTimeRulerClick($event)">
			<time-ruler #timeRuler></time-ruler>
		</div>
		<div class="endscreen-toggle-area" [class.endscreen-enabled]="endscreenEnabled" (click)="$event.stopPropagation()">
			<label>
				<span class="label-text">endscreen</span>
				<bb-info [contents]="'HELP.INTERACTIVITY_ENDSCREEN' | translate" [icon]="'help'"></bb-info>
				<input type="checkbox" name="endscreenToggle" [(ngModel)]="endscreenEnabled" (ngModelChange)="endscreenChange($event)" />
			</label>
		</div>
	</div>
</div>
<tracks 
	[showGhost]="showGhost" 
	[widgetType]="widgetType" 
	(onTrackSelected)="newWidgetConfig = $event"
	class="tracks">
</tracks>
<bb-resizable-scrollbar *ngIf="interactivityEditorService.parentEntityType === 'MediaClip'" [subject]="interactivityEditorService.trackZoomSubject"></bb-resizable-scrollbar>
<div *ngIf="interactivityEditorService.parentEntityType === 'MediaClip'" class="timeline-indicator-top" [class.endscreen-enabled]="endscreenEnabled">
	<div class="left-space"></div>
	<div class="bb-track-zoom">
		<div class="container" #timeContainer>
			<div #timeIndicator class="timeline-indicator-body" 
				bbDrag
				[bbDragContainer]="timeContainer"
				[bbDragAxis]="'x'"
				(bbDragMoved)="onTimeIndicatorDragging($event)"
				(bbDragEnded)="onTimeIndicatorDragEnd($event)"
			>
				<div *ngIf="interactivityEditorService.parentEntityType === 'MediaClip'" class="timeline-indicator-handle-container">
					<img alt="" src="/resources/img/interactivity/timeline-handle.svg"/>
				</div>
				<div class="timeline-indicator-container">
					<div class="timeline-indicator"></div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="extra-area-wrapper" [class.endscreen-enabled]="endscreenEnabled">
	<div></div>
	<div class="extra-area-overlay-wrapper">
		<div class="bb-track-zoom">
			<div class="extra-area-overlay" [ngStyle]="extraAreaStyle">
				
			</div>
		</div>
	</div>
</div>
